import React, { useState } from 'react'
import './AboutEdit.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutEdit = (props) => {
    const [flip, setFlip] = useState(props.orientation)


    return (
        <div className='col-10 h-100 mx-auto About-container'>
            <div className='row'>
                {flip === false && <>
                    <div data-aos='fade-left' data-aos-delay="250" className='col text-left mx-auto TextAbout'>
                        <h1 className='AboutTitle'><span>{props.title}</span> <span className='text-secondary'>{props.grey}</span></h1>
                        <p className='AboutText'>{props.text}</p>
                    </div>
                    <img data-aos='fade-left' className='col mx-auto About-img' src={props.url} />
                </>}

                {flip === true && <>
                    <img data-aos='fade-right' className='col mx-auto About-img' src={props.url} />
                    <div data-aos='fade-right' data-aos-delay="250" className='col text-left mx-auto TextAbout'>
                        <h1 className='AboutTitle'>{props.title} <span className='text-secondary'>{props.grey}</span></h1>
                        <p className='AboutText'>{props.text}</p>
                    </div>
                </>}

                
            </div>
        </div>
    )
}

export default AboutEdit
